import { Button, Flex, Grid, ProductModal } from '@raskrask-dk/rr-components'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { BasisTypeBF, GoalBF, PartnerBF } from '../../../models'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { getIsMobile } from '../../../redux/reducers/appSettings'
import { setActiveTab } from '../../../redux/reducers/calendarSettings'
import { stripHTML } from '../../../services/stripHTML'

export const PartnerInfoModal = ({
  setInspectedPartner,
  setIsModalOpen,
  setPartner,
  goNext,
  selectedGoal,
  inspectedPartner,
  basisType,
}: {
  setIsModalOpen: (i: boolean) => void
  setInspectedPartner: (partner: PartnerBF | undefined) => void
  setPartner: (p: PartnerBF | undefined) => void
  goNext: () => void
  selectedGoal: GoalBF
  inspectedPartner: PartnerBF | undefined
  basisType: BasisTypeBF
}): ReactElement => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const isMobile = useAppSelector((state) => getIsMobile(state))
  const onClickClose = () => {
    // go back to partner selection
    setInspectedPartner(undefined)
    setIsModalOpen(false)
  }

  const onClickCTA = () => {
    // select partner and go to details state
    setPartner(inspectedPartner)
    goNext()
  }

  const competences =
    selectedGoal && inspectedPartner
      ? inspectedPartner
        .competencesForGoal(selectedGoal)
        .map((competence) => {
          return {
            icon: competence.picture,
            title: competence.name,
            content: competence.text,
          }
        })
      : []

  const reviews = inspectedPartner
    ? inspectedPartner.reviews.map((review) => {
      return {
        name: review.name,
        comment: review.comment,
        rating: review.rating,
        date: review.date.toString('dd/MM/yyyy'),
      }
    })
    : []

  return inspectedPartner ? (
    <ProductModal
      activeTab={'Book'}
      competencesTab={{
        competences: competences,
        hide: ![2, 3].includes(basisType.id),
        label: t(`calendar.modalnav.competences`),
      }}
      footerButtons={
        <Grid gap="4">
          <Flex gap="8">
            <Button
              onClick={onClickCTA}
              size="large"
              variant="success"
              data-cy="PartnerModalCTA"
              disabled={false}
            >
              Vælg {inspectedPartner.alias}
            </Button>
          </Flex>
        </Grid>
      }
      onClose={onClickClose}
      onChangeTab={(tab) => dispatch(setActiveTab(tab))}
      open
      noReviewsText={t('common:newatraskrask')}
      numberOfReviews={inspectedPartner.numberOfReviews}
      productImage={inspectedPartner.therapistPictureLink}
      productName={inspectedPartner.alias}
      profileTab={{
        educations: inspectedPartner.education,
        educationText: t('calendar.profile.education', {
          provider: t(
            `common:basistypes.${basisType.id}.singularis`
          ).toLowerCase(),
        }),
        label: t(`calendar.modalnav.profile`),
        profileText:
          selectedGoal &&
          stripHTML(
            inspectedPartner.profileTextForGoal(selectedGoal) || ''
          ),
        readMoreText: (readMore) =>
          t(`common:show${readMore ? 'less' : 'more'}`),
      }}
      rating={inspectedPartner.rating}
      reviewsTab={{
        label: t(`calendar.modalnav.reviews`),
        noReviewsText: t('common:noreviews', {
          person: inspectedPartner.alias,
        }),
        ratingText: t('calendar.reviews.trustpilot'),
        reviews: reviews,
      }}
      type={isMobile ? 'drawer' : 'modal'}
    />
  ) : (
    <></>
  )
}
